import React, { useState } from 'react';
import { Popover, Tooltip } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { PALETTE } from '../../../consts/AppointmentStatusColors';
import styles from './ColorPicker.module.css';

const Swatch = ({ colors }) => (
    <span
        className={styles.swatch}
        style={{ background: colors?.bg || '#ffffff', borderColor: colors?.borderColor || '#c4c9d4' }}
    />
);

/**
 * Bolinha de cor que abre a paleta curada (PALETTE). value = chave escolhida ou
 * null (vale a cor padrão, mostrada como a primeira opção com defaultLabel).
 */
function ColorPicker({ label, value, defaultColors, defaultLabel = 'Padrão', disabled, onChange }) {
    const [anchor, setAnchor] = useState(null);
    const current = (value && PALETTE[value]) || defaultColors;
    const currentName = value && PALETTE[value] ? PALETTE[value].label : defaultLabel;

    const pick = (key) => {
        setAnchor(null);
        if (key !== value) onChange(key);
    };

    return (
        <>
            <Tooltip title={disabled ? currentName : `${label}: ${currentName}`} arrow>
                <span>
                    <button
                        type="button"
                        className={styles.trigger}
                        onClick={(event) => setAnchor(event.currentTarget)}
                        disabled={disabled}
                        aria-label={`${label}: ${currentName}`}
                    >
                        <Swatch colors={current} />
                    </button>
                </span>
            </Tooltip>
            <Popover
                open={Boolean(anchor)}
                anchorEl={anchor}
                onClose={() => setAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{ paper: { className: styles.paper } }}
            >
                <div className={styles.title}>{label}</div>
                <button type="button" className={styles.option} onClick={() => pick(null)}>
                    <Swatch colors={defaultColors} />
                    <span className={styles.optionLabel}>{defaultLabel}</span>
                    {!value && <CheckRoundedIcon className={styles.check} />}
                </button>
                <div className={styles.grid}>
                    {Object.entries(PALETTE).map(([key, colors]) => (
                        <Tooltip key={key} title={colors.label} arrow>
                            <button
                                type="button"
                                className={`${styles.gridOption} ${value === key ? styles.selected : ''}`}
                                onClick={() => pick(key)}
                                aria-label={colors.label}
                                aria-pressed={value === key}
                            >
                                <Swatch colors={colors} />
                            </button>
                        </Tooltip>
                    ))}
                </div>
            </Popover>
        </>
    );
}

export default ColorPicker;
